import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import About from "@/components/site/About";
import Process from "@/components/site/Process";
import Products from "@/components/site/Products";
import Gallery from "@/components/site/Gallery";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import IndiaCities from "@/components/site/IndiaCities";
import { Seo, HOME_SEO } from "@/components/site/Seo";
import { CITIES, cityPath } from "@/data/cities";
import CityPage from "@/pages/CityPage";
import { CncPatterns } from "@/components/site/CncPatterns";
import { RouteScroll } from "@/components/site/RouteScroll";
import FinishPage from "@/pages/FinishPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
    <div className="bg-ink text-bone font-body" data-testid="app-root">
      <RouteScroll />
      <Navbar />
      <main>
      <Routes>
        <Route path="/" element={<>
        <Seo {...HOME_SEO} />
        <Hero />
        <EditorialMarquee />
        <About />
        <Process />
        <Products />
        <CncPatterns />
        <Gallery />
        <Reviews />
        <IndiaCities />
        </>} />
        <Route path="/finishes/:slug" element={<FinishPage />} />
        {CITIES.map((c) => <Route key={c.slug} path={cityPath(c)} element={<CityPage city={c} />} />)}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </main>
      <Contact />
    </div>
    </BrowserRouter>
  );
}

export default App;
